module.exports = __webpack_public_path__ + "img/arrows-up-down-dark-green.14219dfd.svg";